(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blogs"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function(){
    $('.b-m-wrap select').select2({
        minimumResultsForSearch: Infinity
    });
    $('#blog-change').on('change', function () {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
    window.location = url; // redirect
    }
    return false;
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-influencer"]) return;
  try {
    

    $(function () {
    PROJ.collection.init();
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    

    $(function () {
    PROJ.collection.init();
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["com-hero-imagevideo"] && !Shopify.designMode) return;
  try {
    

    $(document).ready(function ()
    {
    PROJ.hero.init();
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-2021-sk"]) return;
  try {
    

    $(function () {
    PROJ.products.init();
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-type2"]) return;
  try {
    

    $(function () {
    PROJ.products.init();
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

    $(function () {
    PROJ.products.init();
    });



  } catch(e) { console.error(e); }
})();
})();
